import { render, staticRenderFns } from "./modalConfirmSendDocumentV2.vue?vue&type=template&id=31e853ee&"
import script from "./modalConfirmSendDocumentV2.vue?vue&type=script&lang=js&"
export * from "./modalConfirmSendDocumentV2.vue?vue&type=script&lang=js&"
import style0 from "./modalConfirmSendDocumentV2.vue?vue&type=style&index=0&id=31e853ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports